import { selectExternalInfos } from '@/domain/external/external.selectors';
import { useAppSelector } from '@/ui/hook/store';

import { Layout } from './Layout';
import { WelcomeMessage } from './WelcomeMessage';

export function Step1Start({
  welcomeText,
  onClickStartForm,
}: {
  welcomeText: string;
  onClickStartForm: () => void;
}) {
  const infos = useAppSelector(selectExternalInfos);
  return (
    <Layout userName={infos.userName}>
      <WelcomeMessage
        userName={infos.userName}
        welcomeText={welcomeText}
        onClickStartForm={onClickStartForm}
      />
    </Layout>
  );
}
